import React from "react";

export const CardHeader = React.memo(function CardHeader({
  icon: Icon,
  iconBg,
  iconColor,
  title,
  action,
}) {
  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-2.5">
        <span
          className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0"
          style={{ background: iconBg }}
        >
          <Icon size={16} style={{ color: iconColor }} />
        </span>
        <h3 className="text-[13px] font-bold tracking-wide text-slate-800 uppercase">{title}</h3>
      </div>
      {action}
    </div>
  );
});